import React, { useEffect, useState } from 'react';
import AgGridTable from '../components/table/AgGridTable';
import { Box, Chip, CircularProgress, Tooltip, Typography, useTheme } from '@mui/material';
import { ColDef } from 'ag-grid-community';
import axiosInstance from '../axios/axios';
import { useSelector } from 'react-redux';

import CIS_IMG from "../assets/baseVersion/CIS.svg";
import Spark_Text_Img from "../assets/baseVersion/Details_Spark.svg";
// import spark_dark from "../../assets/spark_dark.svg";
import NIST_IMG from "../assets/baseVersion/Nist.svg";
import WhiteTooltip from '../components/WhiteTooltip';

const NistBenchmarksTable = ({rowid}:any) => {
    const [isrowData, setRowData] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);
      const theme = useTheme();
      const isDarkMode = theme.palette.mode === "dark";

    const selectedId = useSelector(
        (state: any) => state.NISTComplianceSelectedRowID?.NISTComplianceSelected
      );


      console.log("selectedId", selectedId);
      

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await axiosInstance.get(
          `/securityscan/controls?control_id=${rowid}`
        );
        setRowData(response.data.data.controls);
      } catch (error) {
        console.error("Error fetching controls:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [rowid]);

  // const rowData = isrowData?.map((control) => ({
  //   id: control.id,
  //   name: control.name,
  //   benchmarks: control.benchmarks.map((benchmark:any)=>
  //     benchmark.trim()),
  //   percentage: control.percentage,
  //   tags: control.tags.map((tag: any) => tag.trim()).join(", "),
  // }));

  const rowData = isrowData?.map((control:any) => ({
    id: control.id,
    name: control.name,
    benchmarks: control?.benchmarks,
    percentage: control.percentage,
    tags: control.tags.map((tag: string) => tag.trim()).join(", "),
  }));

  const columnDefs: ColDef[] = [
    {
      field: "benchmarks",
      headerName: "Benchmark",
      maxWidth: 150,
      // valueGetter: (params: any) => params.node.rowIndex + 1,
      cellRenderer: (params: any) => {
        const values = Array.isArray(params.value)
          ? params.value
          : [params.value];
        const benchmarkImages: Record<string, string> = {
          CIS:   CIS_IMG,
          SPARK:  Spark_Text_Img,
          NIST: NIST_IMG,
        };

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "6px",
            }}
          >
            {values.map((benchmark: string) =>
              benchmarkImages[benchmark] ? (
                <img
                  key={benchmark}
                  src={benchmarkImages[benchmark]}
                  alt={benchmark}
                  style={{
                    width: benchmark === "CIS" ? "30px" : "70px",
                    height: "40px",
                    objectFit: "contain",
                  }}
                />
              ) : null
            )}
          </div>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },

    {
      field: "name",
      headerName: "Recommendation",
      filter: true,
      minWidth: 200,
      flex: 1,
      cellRenderer: (params: any) => {
        const value = params.value || "";
        // const shouldTruncate = value.length > 100;

        return (
          <WhiteTooltip title={value} arrow placement="top">
            <span style={{ width: "100%" }}>
              <Typography
                variant="body2"
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "inline-block",
                  width: "100%",
                  fontWeight: "700",
                }}
              >
                {value}
              </Typography>
            </span>
          </WhiteTooltip>
        );
      },
      cellStyle: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
      },
    },
    {
      field: "tags",
      headerName: "Tag",
      filter: true,
      minWidth: 80,
      width: 180,
      cellStyle: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      },
      cellRenderer: (params: any) => {
        const getRandomColor = () => {
          const hue = Math.floor(Math.random() * 360);
          return {
            background: `hsl(${hue}, 70%, 80%)`,
            color: `hsl(${hue}, 50%, 20%)`,
          };
        };

        const tagString = params.data?.tags || "";
        const tagsArray = tagString
          .split(",")
          .map((tag: any) => tag.trim())
          .filter(Boolean);

        const visibleTags = tagsArray.slice(0, 1);
        const hiddenTags = tagsArray.slice(1);

        return (
          <div style={{ display: "flex", flexDirection: "row", gap: 4 }}>
            {visibleTags.map((tag: string, index: number) => {
              let style = {};
              if (index === 0) {
                style = {
                  backgroundColor: "#0485C21A",
                  color: "#0485C2",
                };
              } else if (index === 1) {
                style = {
                  backgroundColor: "#67000424",
                  color: "#670004",
                };
              } else {
                const random = getRandomColor();
                style = {
                  backgroundColor: random.background,
                  color: random.color,
                };
              }

              return (
                <Chip
                  key={index}
                  label={tag}
                  style={{
                    ...style,
                    fontWeight: "bold",
                    borderRadius: 4,
                  }}
                />
              );
            })}

            {hiddenTags.length > 0 && (
              <WhiteTooltip title={hiddenTags.join(", ")} arrow placement="top">
                <div
                  style={{
                    backgroundColor: "#ccc",
                    borderRadius: "50%",
                    width: 32,
                    height: 32,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                    fontSize: 14,
                    cursor: "pointer",
                  }}
                >
                  +{hiddenTags.length}
                </div>
              </WhiteTooltip>
            )}
          </div>
        );
      },
    },

    {
      field: "percentage",
      headerName: "Compliance",
      filter: true,
      minWidth: 120,
      cellRenderer: (params: any) => {
        const value = Math.floor(params.value) || 0;

        // Choose progress color based on value
        const progressColor =
          value >= 75 ? "green" : value >= 50 ? "orange" : "red";

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Box
              sx={{
                position: "relative",
                display: "inline-flex",
                width: 40,
                height: 40,
              }}
            >
              {/* Background Circle */}
              <CircularProgress
                variant="determinate"
                value={100}
                size={30}
                thickness={5}
                sx={{
                  color: "#c5c5d2", // background circle
                }}
              />
              {/* Foreground Progress */}
              <CircularProgress
                variant="determinate"
                value={value}
                size={30}
                thickness={5}
                sx={{
                  color: progressColor,
                  position: "absolute",
                  left: 0,
                }}
              />
            </Box>
            <Typography variant="body2" fontWeight={600} sx={{ minWidth: 30 }}>
              {`${value}%`}
            </Typography>
          </Box>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
  ];

  return (
    <div
    style={{
      height: "calc(74vh - 95px)",
      display: "flex",
      flexDirection: "column",
      overflow: "auto",
      scrollbarWidth:"none"
    }}
  >
    <AgGridTable
      columnDefs={columnDefs}
      data={rowData}
      showSearch
      isRowSelectable
      height={"calc(72vh - 110px)"}
      isLoading={isLoading}
    />
  </div>
  );
}
export default NistBenchmarksTable;



